import { useQuery } from '@tanstack/react-query';

import { toastError } from 'common/toast';
import { fetchSupportedApplications } from 'api/supported-applications';

import { APIKeys } from 'common/enum/api-keys.enum';
import { SupportedApplications } from 'common/types/supported-applications.type';

export const useSupportedApplications = () => {
  const { data, refetch, isFetching } = useQuery<SupportedApplications>({
    queryFn: () => fetchData(),
    refetchOnWindowFocus: false,
    queryKey: [APIKeys.SUPPORTED_APPLICATIONS],
  });

  const fetchData = async (): Promise<SupportedApplications> => {
    try {
      const supportedApplications = await fetchSupportedApplications();

      return supportedApplications;
    } catch (error: any) {
      toastError('Failed to fetch supported applications', error);

      throw error;
    }
  };

  return {
    fetch: refetch,
    isLoading: isFetching,
    supportedApplications: data,
  };
};
